import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import PasswordResetConfirmation from '../../pages/PasswordResetConfirmation'
import { submitPasswordChange } from '../../actions/passwordResetConfirmation'
import { executeRecaptcha } from '../../actions/secureForm'
import { getSiteKey } from '../../selectors/initialization'
import {
  getErrorCode,
  getProcessed,
  getDisabledForm
} from '../../selectors/formCommon'

export const mapStateToProps = createSelector(
  [getSiteKey, getErrorCode, getProcessed, getDisabledForm],
  (siteKey, errorCode, processed, disabledForm) => ({
    siteKey,
    errorCode,
    processed,
    disabledForm
  })
)

export const mapDispatchToProps = dispatch => ({
  onSubmit: ({ password, passwordConfirmation, token, recaptchaResponse }) =>
    dispatch(
      submitPasswordChange({
        password,
        passwordConfirmation,
        token,
        recaptchaResponse
      })
    ),
  onExecuteRecaptcha: () => dispatch(executeRecaptcha())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetConfirmation)
